export const BROWSER_NOTIFICATION = {
                                        texts:{
                                                    button_1:'Allow',
                                                    button_2:'Cancel',
                                                    message:'Message'
                                              }
                                    }
